var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayBtnAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11a1 1 0 00-1 1v16a1 1 0 001 1h4a1 1 0 001-1V12a1 1 0 00-1-1h-4zM23 11a1 1 0 00-1 1v16a1 1 0 001 1h4a1 1 0 001-1V12a1 1 0 00-1-1h-4z",
    fill: "#fff"
  })));
}

export default SvgPlayBtnAudio;